module.exports = __webpack_public_path__ + "static/assets/ed53497b67d784119a97c4bba0a93034.svg";